// extracted by mini-css-extract-plugin
export default {"form":"Account_form__9eNW7","field":"Account_field__tl1cI","side_by_side":"Account_side_by_side__E-qp4","submit_button":"Account_submit_button__wkq6M"};